import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home'),
    redirect: '/formSite',
  },
  {
    path: '/formSite',
    name: 'Home',
    component: () => import('@/views/Home'),
  },
  {
    path: '/pageSite',
    name: 'PageSite',
    component: () => import('@/views/PageSite')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404')
  },
  {
    path: '/Signin',
    name: 'Signin',
    component: () => import('@/views/Signin')
  },
  {
    path: '/super',
    name: 'super',
    component: () => import('@/views/superFlow')
  },
  {
    path: '/seat',
    name: 'seat',
    component: () => import('@/views/seatArea')
  }
]

export default new Router({
  routes
  // mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js